import { Component } from "react"
import { Field, WrappedFieldProps } from "redux-form"
import React from "react"
import styled, { css } from "styled-components"
import Color from "../../../../../../../style/enum/color"
import {
  Wrapper,
  Title,
  Error,
} from "../../../../../../../components/parts/styled-field/style-components/style"
import { media } from "../../../../../../../style/const/media-query"
import { configForCurrentEnv } from "../../../../../../../config/environment"

export interface IStyledUrlFieldProps<P = {}> {
  name: string
  title: string
  placeholder: string
}

interface IProps extends IStyledUrlFieldProps, WrappedFieldProps {}

interface IState {
  onFocus: boolean
}

export default class StyledUrlField extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      onFocus: false,
    }
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  public render() {
    const props = this.props
    return (
      <Wrapper>
        <Title active={this.state.onFocus} htmlFor={props.name}>
          {props.title}
        </Title>
        <UrlWrapper>
          <Url>{configForCurrentEnv.endpoints.app}/channel/</Url>
          <FieldWrapper active={this.state.onFocus}>
            <Field
              name={props.input.name}
              component="input"
              type="text"
              placeholder={props.placeholder}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />
          </FieldWrapper>
        </UrlWrapper>
        {props.meta.touched && props.meta.error && (
          <Error>{props.meta.error}</Error>
        )}
      </Wrapper>
    )
  }

  private onFocus() {
    this.setState({
      onFocus: true,
    })
  }

  private onBlur() {
    this.setState({
      onFocus: false,
    })
  }
}

const FieldWrapper = styled.div<{ active: boolean }>`
  width: 100%;
  transition: 0.3s;
  border: 1px solid ${({ active }) => (active ? Color.BRAND : Color.LIGHT_GRAY)};
  border-radius: 5px;
  overflow: hidden;
  input {
    width: 100%;
    height: 35px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

const Url = styled.b`
  margin-right: 8px;
  font-size: 1.1rem;
  line-height: 2.1;
  ${media.phone(css`
    margin-right: 4px;
    font-size: 0.7rem;
    line-height: 3.2;
  `)}
`

const UrlWrapper = styled.div`
  width: 100%;
  display: flex;
`
